export default "__VITE_ASSET__DIlTZCv6__"